
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerEditor("Matrix.Rebalancer.SummaryViewInstanceGrid", [Serenity.IReadOnly])
    @Serenity.Decorators.element("<div/>")
    export class SummaryViewInstanceGrid extends SiteEntityGrid<SummaryViewInstanceRow, any>
        implements Serenity.IReadOnly {
        protected getColumnsKey() { return 'Rebalancer.SummaryViewInstance'; }
        protected getDialogType() { return SummaryViewInstanceDialog; }
        protected getIdProperty() { return SummaryViewInstanceRow.idProperty; }
        protected getLocalTextPrefix() { return SummaryViewInstanceRow.localTextPrefix; }
        protected getService() { return SummaryViewInstanceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getInitialTitle() {
            return null;
        }

        private _viewCode: string;

        public set viewCode(value: string) {
            if (this._viewCode !== value) {
                this._viewCode = value;
                this.setEquality(SummaryViewInstanceRow.Fields.ViewCode, value);
                this.refresh();
            }
        }

        protected addButtonClick() {
            this.editItem(<SummaryViewInstanceRow>{
                ViewCode: this._viewCode
            });
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._viewCode;
        }

        protected updateInterface() {
            this.toolbar.findButton('add-button').toggle(!this._readOnly && !!this._viewCode);
        }

        private _readOnly: boolean;

        get_readOnly(): boolean {
            return !!this._readOnly;
        }

        set_readOnly(value: boolean): void {
            if (!!this._readOnly !== !!value) {
                this._readOnly = !!value;
                this.updateInterface();
            }
        }
    }
}